var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMsgFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "UI icon/message/filled"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtract",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.33301 4C1.33301 2.89543 2.22844 2 3.33301 2H12.6663C13.7709 2 14.6663 2.89543 14.6663 4V10.6667C14.6663 11.7712 13.7709 12.6667 12.6663 12.6667H5.57437C5.41842 12.6667 5.26739 12.7213 5.14758 12.8212L3.51992 14.1776C2.65148 14.9013 1.33301 14.2837 1.33301 13.1533V4ZM4.66634 6C4.66634 5.63181 4.96482 5.33333 5.33301 5.33333H10.6663C11.0345 5.33333 11.333 5.63181 11.333 6C11.333 6.36819 11.0345 6.66667 10.6663 6.66667H5.33301C4.96482 6.66667 4.66634 6.36819 4.66634 6ZM5.33301 8C4.96482 8 4.66634 8.29848 4.66634 8.66667C4.66634 9.03486 4.96482 9.33333 5.33301 9.33333H7.99967C8.36786 9.33333 8.66634 9.03486 8.66634 8.66667C8.66634 8.29848 8.36786 8 7.99967 8H5.33301Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMsgFilled);
export default __webpack_public_path__ + "static/media/msg-filled.f585c4224859e85b6aa622d87f618e96.svg";
export { ForwardRef as ReactComponent };